export default __webpack_public_path__ + "static/DSC_0004-5d9ad999b1745a454e8b5879d129e055.jpg";